import LogoutEscapeLink from "@/components/LogoutEscapeLink";
import UserProfile from "@/domain/entities/user/UserProfile";
import useOrganization from "@/hooks/useOrganization";
import { accountIdentityFromUserProfile } from "@/mappers/user/accountIdentityMapper";
import { useTranslation } from "react-i18next";
import NoLicenseView from "./NoLicenseView";

type NoLicenseOrganizationProps = {
    user: UserProfile;
};

const NoLicenseOrganization = ({ user }: NoLicenseOrganizationProps) => {
    const { t } = useTranslation();
    const { organization } = useOrganization();
    const organizationName = organization?.name;

    return (
        <NoLicenseView
            account={accountIdentityFromUserProfile(user)}
            accountAction={
                <LogoutEscapeLink
                    className="shrink-0 text-purple-700"
                    variant="link"
                />
            }
            description={
                organizationName
                    ? t("noLicense.organization.description", {
                          organizationName,
                      })
                    : t("noLicense.organization.descriptionFallback")
            }
            title={t("noLicense.organization.title")}
        />
    );
};

export default NoLicenseOrganization;
